import { transType } from './static'
import { getTransTypeUri } from './transTypeUri'

// Jenis transaksi kas & bank yang bisa diajukan approval (lihat ApprovalsTable).
// Detailnya berada di bawah akun bank, jadi butuh bank_account_id.
const BANK_TRANS_TYPES = [
  transType.SPEND_MONEY,
  transType.RECEIVE_MONEY,
  transType.EXPENSE_PAYMENT,
  transType.PURCHASE_PAYMENT,
  transType.RECEIVE_INVOICE_PAYMENT,
  transType.RECEIVE_SALES_ORDER_PAYMENT,
  transType.PURCHASE_ORDER_PAYMENT,
]

// Semua field `data` FCM berupa string.
const toId = (value) => {
  const id = Number(value)
  return Number.isInteger(id) && id > 0 ? id : null
}

/**
 * Susun record untuk getTransTypeUri dengan cara yang sama seperti halaman
 * Approval membentuk link detailnya. Null bila field yang dibutuhkan jenis
 * transaksi itu belum dikirim BE.
 */
const toRecord = (transTypeId, data) => {
  // Penutupan buku & penyesuaian stok: halaman detailnya memakai
  // business_tran_id, bukan id transaksi approval (ref_id).
  if (transTypeId === transType.CLOSING) {
    const businessTranId = toId(data.business_tran_id)
    return businessTranId ? { id: businessTranId } : null
  }
  if (transTypeId === transType.STOCK_ADJUSTMENT) {
    const businessTranId = toId(data.business_tran_id)
    const warehouseId = toId(data.warehouse_id)
    return businessTranId && warehouseId ? { id: businessTranId, warehouseId } : null
  }

  const id = toId(data.ref_id)
  if (!id) {
    return null
  }
  if (transTypeId === transType.WAREHOUSE_TRANSFER) {
    const warehouseId = toId(data.from_warehouse_id)
    return warehouseId ? { id, warehouseId } : null
  }
  if (BANK_TRANS_TYPES.includes(transTypeId)) {
    const accountId = toId(data.bank_account_id)
    return accountId ? { id, accountId } : null
  }
  return { id }
}

/**
 * Path detail transaksi dari push approval (`data.trans_type_id` +
 * `data.ref_id`), sama seperti aplikasi mobile. Null — pemanggil memakai
 * web_url — bila push berasal dari perusahaan lain, field tambahan jenis
 * transaksinya belum dikirim BE, user tidak punya izin membuka halaman itu,
 * atau jenis transaksinya tidak dikenal.
 * @param {object} data - `data` dari payload FCM.
 * @param {{permissions?: string[], websiteId?: number}} [context] - Izin user
 *   dan website_id perusahaan yang sedang dibuka.
 * @returns {string|null} Path hash router (mis. `/sales/invoices/detail/12`).
 */
export const getPushTransactionPath = (data, { permissions = [], websiteId } = {}) => {
  if (!data) {
    return null
  }
  const transTypeId = toId(data.trans_type_id)
  if (!transTypeId) {
    return null
  }
  // Satu token menerima push dari semua perusahaan user; id transaksi milik
  // perusahaan lain akan membuka data yang salah di perusahaan yang aktif.
  const pushWebsiteId = toId(data.website_id)
  if (pushWebsiteId && websiteId && pushWebsiteId !== Number(websiteId)) {
    return null
  }
  const record = toRecord(transTypeId, data)
  if (!record) {
    return null
  }
  return getTransTypeUri(transTypeId, record, permissions) || null
}
